import type { Params } from "../toQueryString";
import { buildPath } from "./buildPath";

export const newsletterPosts = {
  list: ({
    newsletterId,
    params = {},
  }: {
    newsletterId: number;
    params?: Params;
  }) => buildPath(`/internal_api/newsletters/${newsletterId}/posts`, params),
  create: ({
    newsletterId,
    params = {},
  }: {
    newsletterId: number;
    params?: Params;
  }) => buildPath(`/internal_api/newsletters/${newsletterId}/posts`, params),
  show: ({
    newsletterId,
    id,
    params = {},
  }: {
    newsletterId: number;
    id: number;
    params?: Params;
  }) =>
    buildPath(`/internal_api/newsletters/${newsletterId}/posts/${id}`, params),
  update: ({
    newsletterId,
    id,
    params = {},
  }: {
    newsletterId: number;
    id: number;
    params?: Params;
  }) =>
    buildPath(`/internal_api/newsletters/${newsletterId}/posts/${id}`, params),
  destroy: ({
    newsletterId,
    id,
    params = {},
  }: {
    newsletterId: number;
    id: number;
    params?: Params;
  }) =>
    buildPath(`/internal_api/newsletters/${newsletterId}/posts/${id}`, params),
  publish: ({
    newsletterId,
    id,
    params = {},
  }: {
    newsletterId: number;
    id: number;
    params?: Params;
  }) =>
    buildPath(
      `/internal_api/newsletters/${newsletterId}/posts/${id}/publish`,
      params,
    ),
  report: ({
    newsletterId,
    id,
    params = {},
  }: {
    newsletterId: number;
    id: number;
    params?: Params;
  }) =>
    buildPath(
      `/internal_api/newsletters/${newsletterId}/posts/${id}/report`,
      params,
    ),
  recipients: ({
    newsletterId,
    id,
    params = {},
  }: {
    newsletterId: number;
    id: number;
    params?: Params;
  }) =>
    buildPath(
      `/internal_api/newsletters/${newsletterId}/posts/${id}/recipients`,
      params,
    ),
  exportRecipients: ({
    newsletterId,
    id,
    params = {},
  }: {
    newsletterId: number;
    id: number;
    params?: Params;
  }) =>
    buildPath(
      `/internal_api/newsletters/${newsletterId}/posts/${id}/export_recipients`,
      params,
    ),
  testEmail: ({
    newsletterId,
    id,
    params = {},
  }: {
    newsletterId: number;
    id: number;
    params?: Params;
  }) =>
    buildPath(
      `/internal_api/newsletters/${newsletterId}/posts/${id}/test_email`,
      params,
    ),
  view: ({ slug, params = {} }: { slug: string; params?: Params }) =>
    buildPath(`/internal_api/newsletter_posts/${slug}`, params),
};
